import { useRequest } from '@Contexts/Request';
import useNavigation from '@Navigation/useNavigation';
import * as PageProductStore from '@Stores/PageProduct';
import queryStringToObject from './helpers/queryStringToObject';

// Возвращает ключи кэширования для конструкторв
function useKeys() {
  const { region, language } = useRequest();
  const { pathname, search } = useNavigation();

  const {
    product: { modelId },
  } = PageProductStore.useData();
  const translite = pathname.split('/product/')[1];
  const newSearchParams = new URLSearchParams(search);
  const selectedPv = queryStringToObject(newSearchParams.toString());
  const addKeys = Object.values(selectedPv);

  return {
    configurator: [
      'configurator-on-page',
      {
        region,
        lang: language.id,
        translite,
        addKeys,
      },
    ],
    filters: ['selected-filters', modelId, region],
    stock: ['stock', modelId, region],
  };
}

export default useKeys;
